import { render, staticRenderFns } from "./Directlink.vue?vue&type=template&id=6fe7f7f4&scoped=true"
import script from "./Directlink.vue?vue&type=script&lang=js"
export * from "./Directlink.vue?vue&type=script&lang=js"
import style0 from "./Directlink.vue?vue&type=style&index=0&id=6fe7f7f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe7f7f4",
  null
  
)

export default component.exports